<template>
  <div class="accessIndex">
        <div class="table_card">
          <div class="table_card__head">
            <v-layout row wrap fill-height>
              <v-flex xs12 lg6 class="head_contain">
                <p class="table_card__head--title">
                  Métodos de pago
                </p>
                <div class="table_card__head--add_button" @click="show_new_method_modal">
                  <span class="material-icons">
                    add
                  </span>
                  Nuevo
                </div>
              </v-flex>
              <v-flex xs12 lg6 class="filter_options">
                <!-- <v-flex class="right">
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="input_solid"
                    v-model="options_table.search"
                  >
                  <img
                    src="@/assets/img/icons/search-icon.svg"
                    class="button_search"
                  >
                </v-flex> -->
                <div
                  class="buttom_reload"
                  @click="$event => getPaymentMethods()"
                >
                  <img src="@/assets/img/icons/refresh-icon.svg">
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div>
            <v-data-table
              v-model="payment_methods"
              :headers="options_table.headers_table"
              :items="payment_methods"
              :search="options_table.search"
              :pagination.sync="options_table.pagination"
              select-all
            >

              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr class="primary_color">
                  <td class="text-xs-center" width="180px">{{ props.item.attributes.author }}</td>

                  <td class="text-xs-center">
                    <span v-if="isCurrentMethod(props.item.id)" class="badge badge_granted"></span>
                    {{ props.item.attributes.link.split("//")[1] }}
                  </td>

                  <td class="text-xs-center email">{{ props.item.attributes.created_at | moment("DD MMMM YYYY - h:mm a") }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>

        </div>

        <v-dialog v-model="new_method_modal" max-width="500px">

          <v-form
            style="background-color: white; padding: 20px;"
            ref="form"
            v-model="valid_form">

            <v-text-field
              id="payment-link"
              v-model="payment_link"
              label="Link de pago"
              hint="*Ingresa el link de pago generado desde tu plataforma de pagos*"
              :rules="linkRules"
              @keyup="linkRules = [true]"
              required>
            </v-text-field>

            <v-btn
              flat
              color="primary"
              class="mt-3"
              @click="validateLink()">
              Agregar
            </v-btn>
          </v-form>

        </v-dialog>

  </div>

</template>

<script>
  export default {
    data(){
      return{
        valid_form: true,
        // search: '',
        options_table:{
          pagination: {
            rowsPerPage: 10
          },
          headers_table:[
            {
              text: 'Autor',
              align: 'center',
              value: 'email'
            },
            {
              text: 'Link de pago',
              align: 'center',
              value: 'link'
            },
            {
              text: 'Fecha y hora',
              align: 'center',
              value: 'date'
            }
          ],
        },
        linkRules: [true],

        new_method_modal: false,
        payment_link: '',
        payment_methods: []
        // filtered_payment_methods: []
      }
    },
    mounted(){
        this.getPaymentMethods()
    },

    methods: {
      isCurrentMethod(methodId){
        return methodId == this.payment_methods[0].id
      },

      show_new_method_modal(){
        this.new_method_modal = true
        this.payment_link = ''
        this.linkRules = [true]
      },

      getPaymentMethods(){
        try {
          this.$http.get('payment_methods',
            {
              params: {
                company: { id: this.getCompany().id }
              },
              headers: {
                "X-Device-ID": this.getDeviceId(),
                "Authorization": 'Bearer ' + this.getUserToken()
              }
            }
          ).then(response => {

            if(response.body.data.length != 0){
              this.payment_methods = response.body.data
              this.updatePaymentMethod(response.body.data[0].attributes.link)
            }

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })

        } catch (e) {
          alert(e.message)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      },

      validateLink(){
        const regex = /http(s?):\/\/[A-Za-z0-9.]+\.[A-Za-z]+(.[A-Za-z]+?)\//i,
              link = document.getElementById('payment-link').value

        if(regex.test(link)){
          this.linkRules = [true]
          this.savePaymentMethod()
          this.new_method_modal = false

        } else this.linkRules = ["Debes ingresar un link de pago valido"]
      },

      savePaymentMethod(){
        const data = {
          link: this.payment_link,
          "user_id": this.getUserId()
        }

        try {
          this.$http.post("payment_methods", {
            data: this.encrypt(data).toString(),
            attributes: this.encrypt(data).toString()
          },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }

          }).then(response => {
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)
            this.getPaymentMethods()

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })

        } catch (e) {
          alert(e.message)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/users/payment_methods/Index.vue